import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=ecca9b5e&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"
import style0 from "./userCard.vue?vue&type=style&index=0&id=ecca9b5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca9b5e",
  null
  
)

export default component.exports